import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddBankCostLookupListFormValues } from '../../../../../interfaces/lookup/bankCost';
import { IAddBankCostOption } from '../../../../../interfaces/lookup/bankCost/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addBankCostOption } from '../../../../../store/lookupSlice/LookupActions';

export const BankCostLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddBankCostLookupListFormValues) => {
        const body: IAddBankCostOption = {
            ...(values as any),
        };

        dispatch(addBankCostOption(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.bankCostOption.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/bankcost', { replace: true });
        }
    }, [lookupSlice.detailsPage.bankCostOption.createStatus]);

    return (
        <Form
            form={form}
            name="bankcost-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage bank cost lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Bank cost',
                        path: '/admin/lookup-lists/bankcost',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/bankcost/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.bankCostOption.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.bankCostOption.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.bankCostOption.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.bankCostOption.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.bankCostOption.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.bankCostOption.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.bankCostOption.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.bankCostOption.fetchStatus} about={'Bank Cost'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Bank cost option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
